import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppRoute } from 'appRoutes'
import {
  FraudAnalysisModelVersionsPage,
  fraudScoreLabelDefinitionsQueryOptions,
  fraudScoreModelsQueryOptions,
  fraudScoreModelVersionsQueryOptions,
} from 'features/fraudAnalysis'
// TODO DASH-3033: Restore with the historyBucket prefetches below.
// import { ModelVersionHistoryBucket } from 'models'

export const Route = createFileRoute(
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType/versions'
)({
  component: FraudAnalysisModelVersionsPage,
  loader: async ({
    context: { queryClient, buildRequest, fraudScoreEntitlement },
    params: { subscriptionId, labelSlug, clientType },
  }) => {
    if (fraudScoreEntitlement === 'disabled') {
      return
    }

    const labelDefinitions = await queryClient.ensureQueryData(
      fraudScoreLabelDefinitionsQueryOptions(buildRequest, subscriptionId)
    )
    const label = labelDefinitions.find((definition) => definition.labelSlug === labelSlug)

    if (label && label.category == null) {
      throw redirect({
        to: AppRoute.FraudAnalysisModelDetailsOverview,
        params: { subscriptionId, labelSlug, clientType },
        replace: true,
      })
    }

    void queryClient.prefetchInfiniteQuery(fraudScoreModelsQueryOptions(buildRequest, subscriptionId, { labelSlug }))
    void queryClient.prefetchInfiniteQuery(
      fraudScoreModelVersionsQueryOptions(buildRequest, subscriptionId, labelSlug, clientType)
    )
    // TODO DASH-3033: Replace the unfiltered prefetch above when Legendary Blade supports historyBucket.
    // void queryClient.prefetchInfiniteQuery(
    //   fraudScoreModelVersionsQueryOptions(buildRequest, subscriptionId, labelSlug, clientType, {
    //     historyBucket: ModelVersionHistoryBucket.Versions,
    //   })
    // )
    // void queryClient.prefetchInfiniteQuery(
    //   fraudScoreModelVersionsQueryOptions(buildRequest, subscriptionId, labelSlug, clientType, {
    //     historyBucket: ModelVersionHistoryBucket.Discarded,
    //   })
    // )
  },
})
